import React from "react";

// Slow drifting purple mist + subtle dark vignette + grain.
// Used as an absolutely positioned layer behind page content.
export const Mist = ({ intensity = "normal" }) => {
  const opacity = intensity === "soft" ? 0.65 : 1;
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{ opacity }}
      data-testid="kek-mist-layer"
    >
      <div className="kek-mist-a absolute -inset-[10%]" />
      <div className="kek-mist-b absolute -inset-[10%]" />
      <div className="kek-grain absolute inset-0" />
    </div>
  );
};

export default Mist;
